"use client";

import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import Image from "next/image";
import { SITE_LOGO, SITE_LOGO_ALT, SITE_NAME_UPPER } from "@/constants/site";

// ✅ Textes et couleurs animés
const changingTexts = [
  "Recouvrement de créances",
  "Gestion des factures impayées",
  "Suivi des relances clients",
  "Solutions de recouvrement",
];

const colors = ["#FF6B6B", "#4ECDC4", "#FFD93D", "#1A535C", "#FF8C42"];

const textVariants = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  exit: { opacity: 0, y: -40, transition: { duration: 0.4 } },
};

export default function AnimatedCascadeText() {
  const [index, setIndex] = useState(0);

  // ✅ Rotation du texte
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % changingTexts.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const currentText = changingTexts[index];
  const currentColor = colors[index % colors.length];

  return (
    <div className="flex flex-col items-center justify-center h-24 sm:h-32 lg:h-40">
      <div className="flex items-center mr-4 sm:mr-6 lg:mr-8">
        <Image
          src={SITE_LOGO }
          alt={SITE_LOGO_ALT}
          width={32}
          height={32}
          className="mr-2 sm:mr-3 lg:mr-4 sm:w-10 sm:h-10 lg:w-12 lg:h-12"
        />
        <span className="text-xl sm:text-2xl lg:text-3xl font-bold text-left">
          {SITE_NAME_UPPER}
        </span>
      </div>

      <div className="w-72 sm:w-80 lg:w-90 h-10 sm:h-12 lg:h-16 flex items-center justify-center relative overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.span
            key={currentText}
            variants={textVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            className="font-extrabold text-sm sm:text-lg lg:text-2xl absolute left-0 top-0 w-full whitespace-pre text-center"
            style={{ color: currentColor }}
          >
            {currentText}
          </motion.span>
        </AnimatePresence>
      </div>
    </div>
  );
}
